import React, { JSX } from "react";

import QrPanelLayout from "./QrPanelLayout";
import { BillDocumentType } from "../../../../interfaces/BillInterfaces";
import useCanPayWithQr from "../../../../hooks/useCanPayWithQr";
import { TQrPaymentInfo } from "../../../../interfaces/QrPayment";
import Qr from "../../../../components/Qr/Qr";

interface QrPaymentPanelProps {
  draft: BillDocumentType;
  onClose: () => void;
  currentBillCounter: string;
  selectedPaymentMethod: keyof TQrPaymentInfo | null;
}

const QrPaymentPanel = ({
  draft,
  onClose,
  currentBillCounter,
  selectedPaymentMethod
}: QrPaymentPanelProps): JSX.Element => {
  const { paymentMethodToQrMapper } = useCanPayWithQr();
  const { qrS3Url, qrString } = paymentMethodToQrMapper(selectedPaymentMethod);

  return (
    <QrPanelLayout
      title="Pay with QR Code"
      draft={draft}
      onClose={onClose}
      selectedPaymentMethod={selectedPaymentMethod}
      currentBillCounter={currentBillCounter}
    >
      {qrS3Url && <img src={qrS3Url} alt="qr" height="180px" />}
      {!qrS3Url && qrString && <Qr value={qrString} />}
    </QrPanelLayout>
  );
};

export default QrPaymentPanel;
